import { render } from "./MvMainText2.vue?vue&type=template&id=7abc639c"
import script from "./MvMainText2.vue?vue&type=script&lang=js"
export * from "./MvMainText2.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kadowakikiyomi/Documents/PEARLY_GATES/CATALOGUE/PG/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__